import React from "react";
import PageWrapper from "../components/PageWrapper";
import AccessGate from "../components/AccessGate/AccessGate";
import { useAuth, hasRole } from "../context/AuthContext";
import InfrastructureSection from "../sections/infrastructure/InfrastructureSection";
import Seo from "../components/Seo";

const InfrastructurePage = () => {
  const { role, loading } = useAuth();

  if (loading) {
    return (
      <PageWrapper>
        <div style={{ padding: 96, color: "var(--nd-text-primary)" }}>
          loading…
        </div>
      </PageWrapper>
    );
  }

  if (!hasRole(role || "public", "client")) {
    return (
      <PageWrapper>
        <AccessGate
          pageName="Infrastructure"
          purpose="Live map of every junior on every project and the tech stacks in play. Sign in as a client, staff, or admin to view."
          requiredRole="client"
          path="/infrastructure"
        />
      </PageWrapper>
    );
  }

  return (
    <>
      <Seo
        title="Infrastructure Services"
        description="AWS, GCP, Azure landing zones. Terraform modules. EKS / GKE clusters. Multi-region replication. Cost optimization."
        pathname="/infrastructure"
      />
      <PageWrapper>
        <InfrastructureSection />
      </PageWrapper>
    </>
  );
};

export default InfrastructurePage;
